<div class="flex-vertical gap-16 rounded">
  <div class="flex-vertical background-white width-100pc oui-elevation-04 rounded padding-32 gap-48 card">
    <div class="flex-vertical gap-8">
      <h6>{{ modeDeGestionTitle }}</h6>
    </div>
    <div class="flex-vertical gap-24">
      <div class="subtitle-1">Sélectionner un mode de gestion<span class="color-primary-500">*</span></div>
      <div class="flex-vertical toggleContainer">
        <oui-button-toggle
          class="fill"
          [options]="modeDeGestionOptions"
          [control]="modeDeGestionControl"
          [errors]="[requiredValueError]"></oui-button-toggle>
        <div *ngIf="modeDeGestionOptions.length === 1" class="caption color-on-surface-medium">
          Seul ce mode de gestion est disponible pour le produit sélectionné
        </div>
      </div>
      <oui-banner
        *ngIf="messages.length > 0 || showDisponibiliteEpargneMessage"
        type="expandable"
        [declination]="bannerDeclination"
        [title]="bannerTitle"
        [showCloseButton]="false">
        <div class="messages">
          <li class="body-2 color-on-surface-medium" *ngIf="showDisponibiliteEpargneMessage">
            La <span class="bold color-on-surface-high-emphasis">disponibilité de l’épargne</span> sélectionnée dans la
            partie <span class="bold color-primary-500"> exigences et besoins du projet</span>, impose un mode de
            gestion libre.
          </li>
          <li class="body-2 color-on-surface-medium" *ngFor="let message of messages" [innerHTML]="message"></li>
        </div>
      </oui-banner>
    </div>
    <div
      class="flex-vertical gap-16"
      *ngIf="
        currentFicheConseil?.modeDeGestion?.code === 'LIBRE' &&
        fondsEvenementielService.getFondsEvenementielsByModeGestion(currentFicheConseil?.modeDeGestion?.code!).length >
          0 &&
        (currentFicheConseil?.fondsEvenementiels ?? [].length > 0)
      ">
      <div class="subtitle-1">Fonds évènementiels (Exceltis, autres)</div>
      <div class="flex-vertical gap-8">
        <div class="body-2">
          Si nécessaire, sélectionner la ou les gammes de fonds évènementiels comprises dans l'allocation :
        </div>
        <app-fonds-evenementiel-checkbox
          *ngFor="let fonds of fondsEvenementielsWithOrder | orderBy: 'ordre' : []"
          [fonds]="fonds"></app-fonds-evenementiel-checkbox>
      </div>
    </div>
    <div
      class="flex-vertical gap-16"
      *ngIf="
        currentFicheConseil?.modeDeGestion?.code &&
        optionAutomatiqueService.getOptionAutomatiqueByModeGestion(currentFicheConseil?.modeDeGestion?.code!).length >
          0 &&
        (currentFicheConseil?.optionsAutomatiques ?? [].length > 0) &&
        currentFicheConseil?.natureOperation?.id === 1
      ">
      <div class="subtitle-1">Options automatiques</div>
      <div class="flex-vertical gap-8" *ngIf="currentFicheConseil?.optionsAutomatiques ?? [].length > 0">
        <div class="body-2">Sélectionner jusqu'à 2 options automatiques.</div>
        <app-option-checkbox
          *ngFor="let option of optionsAutoWithOrder | orderBy: 'ordre' : []"
          [option]="option"></app-option-checkbox>
      </div>
    </div>
  </div>
  <div
    class="flex-vertical background-white width-100pc oui-elevation-04 rounded padding-32 gap-48 card"
    *ngIf="
      currentFicheConseil?.modeDeGestion?.code &&
      optionAutomatiqueService.getOptionAutomatiqueByModeGestion(currentFicheConseil?.modeDeGestion?.code!).length >
        0 &&
      (currentFicheConseil?.optionsAutomatiques ?? [].length > 0) &&
      currentFicheConseil?.natureOperation?.id === 2 &&
      arbitrageVP?.value
    ">
    <div class="flex-vertical gap-8">
      <h6>Arbitrages programmés</h6>
    </div>
    <div class="flex-vertical gap-16">
      <div class="subtitle-1">Options automatiques<span class="color-primary-500">*</span></div>
      <div class="flex-vertical gap-8" *ngIf="currentFicheConseil?.optionsAutomatiques ?? [].length > 0">
        <div class="body-2" [ngClass]="{ 'color-error': !isStepValid() && stepTouched }">
          Sélectionner 1 à 2 options automatiques sur lesquelles il y'a une mise en place ou une modification.
        </div>
        <app-option-checkbox
          *ngFor="let option of optionsAutoWithOrder | orderBy: 'ordre' : []"
          [option]="option"></app-option-checkbox>
      </div>
    </div>
  </div>
</div>
